import { render, staticRenderFns } from "./QuestionsTemplateWidget.vue?vue&type=template&id=113d43eb&scoped=true"
import script from "./QuestionsTemplateWidget.vue?vue&type=script&lang=js"
export * from "./QuestionsTemplateWidget.vue?vue&type=script&lang=js"
import style0 from "./QuestionsTemplateWidget.vue?vue&type=style&index=0&id=113d43eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113d43eb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VSkeletonLoader,VSwitch,VTextField,VTooltip})
